<dashboard-dialog-frame [header]="'Explorer'" [dialogRef]='dialogRef'>

	<div class='explorer-dialog-content'>
		<div class="explorer-toolbar">
			<div>
				<button class="btn" [disabled]="!nav.canGoBack()" (click)="goBack()"><i class="fas fa-arrow-left"></i></button>
				<button class="btn" [disabled]="!nav.canGoForward()" (click)="goForward()"><i class="fas fa-arrow-right"></i></button>
			</div>

			<div class="selector">
				<droplist [items]='recentItems()' [selectedItem]='currentRecentItem()'
					(selectionChange)='onItemChange($event)' [filterable]='false' [navigation]='true'>
				</droplist>
			</div>

			<button class="btn" (click)="openSearchDialog()"><i class="fas fa-search"></i></button>
		</div>
		<div class="explorer-content-container">
			@switch(currentNoun()){
			@case('Person') {
			<person-explorer></person-explorer>
			}
			@default {
			<p>Coming soon...</p>
			}
			}
		</div>
	</div>

</dashboard-dialog-frame>